module.exports = "/_next/static/resources/array-54b35acc8ed4cfab59e32b64dae39a1a.webp";